import { metricsLogger } from '../metricsLogger';
import { MetricType } from './MetricTypes';
import { CommonUtils } from '../utility/commonUtils';

/**
 * This class provides helper functions for publishing of metrics as cloud watch logs.
 * Metrics published in CWLogs are part of different log group than usual logs.
 */
export class CloudWatchMetrics {
    private static instance : CloudWatchMetrics;

    /**
     * @returns an instance of this class
     */
    public static getInstance(): CloudWatchMetrics {
        if (!CloudWatchMetrics.instance) {
            CloudWatchMetrics.instance = new CloudWatchMetrics();
        }
        return CloudWatchMetrics.instance;
    }

    /**
     * This function publishes metrics data as CWLogs along with additional context if any.
     * @param methodName Method name from where metrics is being published
     * @param metricName Metric name which is being published
     * @param metricType Metric type which is being published
     * @param value Metric value
     * @param context Additional context which is added to CWLogs along with metrics data
     */
    public publishMetricLog(methodName: string, metricName: string, metricType: MetricType, value?: any,
                            context?: any) {

        metricsLogger.info(
            this.buildMetricMessage(methodName, metricName, metricType, value),
            {
                ...context,
                RequestId: CommonUtils.getRequestId(),
                ParentRequestId: CommonUtils.getParentRequestId(),
            }
        );
    }

    /**
     * This Method publishes CW logs and metric log in Embedded metric format(EMF) to directly publish the Metrics along
     * with the dimension as urlPath.
     * KatalLogger provides the support for emiting EMF logs by passing EMF format logs to emfLog parameter in context.
     * Reference - https://tiny.amazon.com/14l90q8ni/codeamazpackKatablobmainREAD
     * @param methodName Method name from where metrics is being published
     * @param metricName Metric name which is being published
     * @param metricType Metric type which is being published
     * @param value Metric value
     * @param urlPath url Path of the page
     * @param context Additional context which is added to CWLogs along with metrics data
     */
    public publishEMFMetricLog(methodName: string, metricName: string, metricType: MetricType, value?: any,
                            urlPath?: string, context?: any) {

        metricsLogger.info(
            this.buildMetricMessage(methodName, metricName, metricType, value),
            {
                ...context,
                RequestId: CommonUtils.getRequestId(),
                ParentRequestId: CommonUtils.getParentRequestId(),
                emfLog: CommonUtils.createEmfLogs(metricName, urlPath)
            }
        );
    }

    private buildMetricMessage(methodName: string, metricName: string, metricType: MetricType, value?: any) {
        return 'METRICS::'
            + metricType + '::'
            + methodName + '::'
            + metricName + '::'
            + (value ? value : '');
    }

}
